
export default {
    name: 'preview-file',
    components: {},
    props: {
        prev_info: {
            type: Object,
            default: () => ({
                file_name: '',
                label: ''
            })
        },
        prev_toggler: Number,
        evolution_id: Number,
        slug: String,
    },

    watch: {
        prev_toggler() {
            this.checkIfCanViewInFrame(this.prev_info.file_name)
        }
    },

    data() {
        return {
            can_view: true,
            asset_url: '',
        }
    },

    computed: {

    },

    mounted() {
        this.asset_url = this.assets_path+'/files/consultation_contents'
    },

    methods: {
        checkIfCanViewInFrame(filename) {
            if (
                filename.includes('pdf') || filename.includes('png') || 
                filename.includes('PNG') || filename.includes('jpeg') || filename.includes('JPEG') || 
                filename.includes('jpg') || filename.includes('JPG') 
            ) {
                this.can_view = true
            } else {
                this.can_view = false
            }
        }
    }
}